import { COUPON_POLES_SET, COUPON_POLES_LOADING, COUPON_POLES_LOADED, COUPON_POLE_UPDATE } from '../actionTypes';
import * as _ from 'lodash';

const initialState = {
    couponsPole: [],
    isPolesOnCoupon: false,
    couponPolesIsLoading: false,
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case COUPON_POLES_SET:
            return {
                ...state,
                couponsPole: action.payload.couponsPole,
                isPolesOnCoupon: action.payload.isPolesOnCoupon,
            };
        case COUPON_POLE_UPDATE:
            const existingPoleIndex = state.couponsPole.findIndex(
                (pole) => pole.IdPolo === action.payload.IdPolo
            );
            let updatedPoles;
            if (existingPoleIndex >= 0) {
                updatedPoles = state.couponsPole.map((pole) =>
                    pole.IdPolo === action.payload.IdPolo
                        ? { ...pole, ...action.payload }
                        : pole
                );
            } else {
                updatedPoles = [...state.couponsPole, action.payload];
            }
            const orderedUpdatedPoles = _.orderBy(updatedPoles, 'Ativo', 'desc');
            const isPoleOnCoupon = _.find(orderedUpdatedPoles, { Ativo: true }) || false;
            return {
                ...state,
                couponsPole: orderedUpdatedPoles,
                isPolesOnCoupon: !!isPoleOnCoupon,
            };
        case COUPON_POLES_LOADING:
            return {
                ...state,
                couponPolesIsLoading: true,
            };
        case COUPON_POLES_LOADED:
            return {
                ...state,
                couponPolesIsLoading: false,
            };
        default:
            return state;
    }
};

export default reducer;
